import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
export default class PlayerTrackInfoComponent extends Component {
  @tracked element;

  @action
  checkOverflow(e) {
    let element = e?.target || this.element;
    if (!element) {
      return;
    }
    if (
      element.scrollWidth > element.parentElement.getBoundingClientRect().width
    ) {
      element.classList.add('has-overflow');
    } else {
      element.classList.remove('has-overflow');
    }
  }
}
